import * as React from "react";
import { Box, Button, Typography } from "@mui/material";
import { styled, alpha } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
// import { useAuth } from "./global_varibles";
import ScheduleDialog from "./shedule_order";

import { ORANGE, ORANGE_HOVER, BLACK, BLACK_ELEV, PREMIUM_SHADOW } from "./global_varibles";

const Pill = styled("span")(({ }) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: 8,
  fontSize: 13,
  fontWeight: 600,
  letterSpacing: 0.75,
  padding: "8px 16px",
  borderRadius: 999,
  backgroundColor: alpha("#fff", 0.06),
  color: alpha("#fff", 0.9),
  backdropFilter: "blur(8px)",
  border: `1px solid ${alpha("#fff", 0.15)}`,
  boxShadow: `0 4px 12px ${alpha("#000", 0.15)}`,
  transition: "all 0.3s ease",
  "&:hover": {
    backgroundColor: alpha("#fff", 0.08),
    borderColor: alpha(ORANGE, 0.3),
    transform: "translateY(-1px)"
  }
}));

const FloatingContainer = styled(Box)(({  }) => ({
  '@keyframes floating': {
    '0%': { transform: 'translateY(0px)' },
    '50%': { transform: 'translateY(-12px)' },
    '100%': { transform: 'translateY(0px)' },
  },
  animation: 'floating 6s ease-in-out infinite',
  transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
  '&:hover': {
    animation: 'none',
    transform: 'scale(1.03) translateY(-8px)',
  },
}));

const FeatureBox = styled(Box)(({  }) => ({
  display: "flex",
  alignItems: "center",
  gap: 12,
  padding: "12px 16px",
  borderRadius: 12,
  backgroundColor: alpha("#fff", 0.03),
  border: `1px solid ${alpha("#fff", 0.06)}`,
  backdropFilter: "blur(4px)",
  transition: "all 0.3s ease",
  "&:hover": {
    backgroundColor: alpha("#fff", 0.06),
    borderColor: alpha(ORANGE, 0.2),
    transform: "translateX(4px)"
  }
}));

function HeroSection() {
  const navigate = useNavigate();
  // const { isAuthenticated } = useAuth();
  const [scheduleDialogOpen, setScheduleDialogOpen] = React.useState(false);

  const handleBook = () => {
    setScheduleDialogOpen(true);
  };

  const handleCloseScheduleDialog = () => {
    setScheduleDialogOpen(false);
  };

  const handlePrices = () => navigate("/prices");
  // const handleLogin = () => navigate("/login");

  return (
    <>
      <Box
        component="section"
        sx={{
          width: "100%",
          background: `linear-gradient(180deg, ${BLACK} 0%, ${BLACK_ELEV} 100%)`,
          borderBottom: `1px solid ${alpha("#fff", 0.08)}`,
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "stretch",
          px: { xs: 3, sm: 4, md: 8 },
          pt: { xs: 6, sm: 8 },
          pb: { xs: 8, sm: 10 },
          gap: { xs: 6, md: 8 },
          minHeight: { md: "85vh" }
        }}
      >
        {/* Left Text Content */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            maxWidth: { md: 600 },
            gap: 3
          }}
        >
          <Pill>✨ Smart Laundry • Fast • Reliable • AI Powered</Pill>

          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: "2.25rem", sm: "3rem", md: "3.75rem" },
              lineHeight: { xs: 1.1, md: 1.05 },
              background: `linear-gradient(135deg, ${ORANGE} 0%, #ffb774 50%, #ffffff 100%)`,
              WebkitBackgroundClip: "text",
              color: "transparent",
              fontWeight: 800,
              letterSpacing: "-0.02em",
              mb: 2
            }}
          >
            Premium Laundry Service, Built for Modern Style
            {/* Expert Care for Your Clothes, So You Can Live Your Life. */}
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: alpha("#fff", 0.8),
              fontSize: { xs: 17, sm: 19 },
              lineHeight: 1.6,
              maxWidth: 520,
              fontWeight: 400
            }}
          >
            <Box component="span" sx={{ display: "block", mb: 1 }}>
              <Box
                component="span"
                sx={{
                  color: ORANGE,
                  fontWeight: 800,
                  mr: 1,
                  fontSize: { xs: 16, sm: 17 }
                }}
              >
                10+ Years in the Industry —
              </Box>
              Track every order in real time, receive instant notifications, and enjoy
              doorstep pickup & delivery. Careful handling for everyday wear and
              delicate fabrics—fast turnaround without compromising quality.
            </Box>
          </Typography>

          <Box
            sx={{
              display: "grid",
              gap: 1.5,
              mt: 2,
              gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" }
            }}
          >
            {[
              "Real-time order tracking",
              "Doorstep pickup & delivery", 
              "Fabric-safe processes",
              "Fast turnaround options"
            ].map((item) => (
              <FeatureBox key={item}>
                <Box
                  sx={{
                    width: 24,
                    height: 24,
                    borderRadius: "50%",
                    background: `linear-gradient(135deg, ${ORANGE} 0%, ${ORANGE_HOVER} 100%)`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 13,
                    fontWeight: 700,
                    color: "#0b0b0b",
                    boxShadow: `0 2px 8px ${alpha(ORANGE, 0.3)}`
                  }}
                >
                  ✓
                </Box>
                <Typography 
                  variant="body2" 
                  sx={{ 
                    color: alpha("#fff", 0.9), 
                    fontWeight: 500,
                    fontSize: 14
                  }}
                >
                  {item}
                </Typography>
              </FeatureBox>
            ))}
          </Box>

          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mt: 4 }}>
            <Button
              variant="contained"
              onClick={handleBook}
              sx={{
                background: `linear-gradient(135deg, ${ORANGE} 0%, ${ORANGE_HOVER} 100%)`,
                color: "#0b0b0b",
                fontWeight: 700,
                textTransform: "none",
                px: 4,
                py: 1.5,
                fontSize: 16,
                borderRadius: 2,
                boxShadow: `0 4px 20px ${alpha(ORANGE, 0.3)}`,
                transition: "all 0.3s ease",
                "&:hover": { 
                  background: `linear-gradient(135deg, ${ORANGE_HOVER} 0%, #d97706 100%)`,
                  transform: "translateY(-2px)",
                  boxShadow: PREMIUM_SHADOW,
                }
              }}
            >
              Book Pickup Now
            </Button>
            <Button
              variant="outlined"
              onClick={handlePrices}
              sx={{
                borderColor: alpha("#fff", 0.2),
                color: alpha("#fff", 0.9),
                fontWeight: 600,
                textTransform: "none",
                px: 4,
                py: 1.4,
                fontSize: 16,
                borderRadius: 2,
                backdropFilter: "blur(4px)",
                "&:hover": {
                  borderColor: ORANGE,
                  backgroundColor: alpha(ORANGE, 0.08),
                  color: "#fff",
                  transform: "translateY(-1px)"
                }
              }}
            >
              View Pricing
            </Button>
          
          </Box>

          <Box
            sx={{
              mt: 5,
              display: "flex",
              flexWrap: "wrap",
              gap: 3,
              alignItems: "center"
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                backgroundColor: alpha("#fff", 0.04),
                px: 2,
                py: 1,
                borderRadius: 2,
                border: `1px solid ${alpha("#fff", 0.08)}`
              }}
            >
              <Box
                sx={{
                  width: 12,
                  height: 12,
                  borderRadius: "50%",
                  backgroundColor: "#10b981",
                  boxShadow: `0 0 0 4px ${alpha("#10b981", 0.2)}`,
                  animation: "pulse 2s infinite"
                }}
              />
              <Typography variant="body2" sx={{ color: alpha("#fff", 0.8), fontWeight: 500 }}>
                Live deliveries active
              </Typography>
            </Box>
            <Typography variant="body2" sx={{ color: alpha("#fff", 0.6) }}>
              ⭐ Trusted by 500+ recurring customers
            </Typography>
          </Box>
        </Box>

        {/* Right Image Area */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mt: { xs: 6, md: 0 }
          }}
        >
          <FloatingContainer
            sx={{
              width: "100%",
              maxWidth: { xs: 450, sm: 550, md: 650 },
              aspectRatio: "1/1",
              position: "relative"
            }}
          >
            <img
              src="/hero_section_3.png"
              alt="Modern laundry service process"
              style={{
                width: "100%",
                height: "100%",   
                objectFit: "contain",
                filter: "drop-shadow(0 20px 40px rgba(0,0,0,0.3))"
              }}
            />
          </FloatingContainer>
        </Box>
      </Box>

      {/* Schedule Dialog */}
      <ScheduleDialog 
        open={scheduleDialogOpen} 
        handleClose={handleCloseScheduleDialog} 
      />
    </>
  );
}

export default HeroSection;